import { render, staticRenderFns } from "./SurveyFreezer.vue?vue&type=template&id=21a06c38&"
import script from "./SurveyFreezer.vue?vue&type=script&lang=js&"
export * from "./SurveyFreezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports